import * as React from 'react';
import { useState, useEffect } from 'react';
import { lightboxOverlay, lightboxContent, closeButton, container, tracked, advbtn } from './advisorylightbox.module.css';
import { useLocation } from "@reach/router";
import { DarkButton } from "../buttons/dark-button";

export function AdvisoryLightbox({ children, title }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation()

  const openLightbox = () => {
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      closeLightbox();
    }
  };

  // Add useEffect to manage body style on component mount and unmount
  useEffect(() => {
    // Disable scrolling when the lightbox is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable scrolling when the lightbox is closed
      document.body.style.overflow = 'visible';
    }

    // Cleanup function to reset body style when the component is unmounted
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [isOpen]);

  return (
    <div>
        <button className={advbtn} onClick={openLightbox}>
          <span className={tracked}>ENQUIRE NOW</span>
        </button>

      {isOpen && (
        <div className={`${lightboxOverlay} ${isOpen ? 'lightboxOpen' : ''}`}>
          <div className={lightboxContent}>
            <span className={closeButton} onClick={closeLightbox}>
              &times;
            </span>
            <button
              className={closeButton}
              onClick={closeLightbox}
              onKeyDown={handleKeyDown}
              tabIndex="0" // Ensure the button is focusable
            >
              &times;
            </button>
            <div className={container}>
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
